import { render, staticRenderFns } from "./CorporateRegister.vue?vue&type=template&id=077cc9b4&scoped=true"
import script from "./CorporateRegister.vue?vue&type=script&lang=js"
export * from "./CorporateRegister.vue?vue&type=script&lang=js"
import style0 from "./CorporateRegister.vue?vue&type=style&index=0&id=077cc9b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077cc9b4",
  null
  
)

export default component.exports